@if (result) {
<div class="results-screen">
  <div class="results-screen__icon" [class.results-screen__icon--passed]="result.passed" [class.results-screen__icon--failed]="!result.passed">
    {{ result.passed ? '\u2713' : '\u2717' }}
  </div>
  <div class="results-screen__score" [class.results-screen__score--passed]="result.passed" [class.results-screen__score--failed]="!result.passed">
    {{ scorePercent }}%
  </div>
  <p class="results-screen__label">
    {{ result.passed ? ('Training_Learner.Results_Passed_Label' | translate) : ('Training_Learner.Results_Failed_Label' | translate) }}
  </p>
  <p class="results-screen__message">
    {{ ('Training_Learner.Results_Message' | translate).replace('%c', result.correct).replace('%t', result.total) }}
    @if (result.passed) {
      {{ 'Training_Learner.Results_Module_Complete' | translate }}
    } @else {
      {{ 'Training_Learner.Results_Try_Again' | translate }}
    }
  </p>

  <div class="results-screen__actions">
    @if (result.passed && certificateUnlocked) {
      <button class="btn btn--purple" (click)="navigate('/certificate')">
        <span [innerHTML]="Icons.trophy | safeHtml"></span> {{ 'Training.My_Training.View_Certificate' | translate }}
      </button>
    }
    @if (result.passed && nextModuleId) {
      <button class="btn btn--primary" (click)="navigate('/module/' + nextModuleId)">
        {{ 'Training_Learner.Next_Module' | translate }} <span [innerHTML]="Icons.arrow_right | safeHtml"></span>
      </button>
    }
    @if (result.passed) {
      <button class="btn btn--secondary" (click)="navigate('/overview')">{{ 'Training_Learner.Back_To_Programme' | translate }}</button>
    } @else {
      <button class="btn btn--primary" (click)="navigate('/quiz/' + result.moduleId)">{{ 'Training_Learner.Retake_Quiz' | translate }}</button>
      <button class="btn btn--secondary" (click)="navigate('/module/' + result.moduleId)">{{ 'Training_Learner.Review_Module' | translate }}</button>
    }
  </div>

  <div class="results-explanations">
    <h3>{{ 'Training_Learner.Question_Review' | translate }}</h3>
    @for (item of result.results; track item.question.id; let i = $index) {
      <div class="result-item" [class.result-item--correct]="item.isCorrect" [class.result-item--incorrect]="!item.isCorrect">
        <p class="result-item__question">{{ ('Training.Learner.Review_Question_Number' | translate).replace('%s', i + 1) }}: {{ item.question.question }}</p>
        @if (!item.isCorrect) {
          <p class="result-item__answer result-item__answer--yours">
            {{ 'Training_Learner.Your_Answer' | translate }}
            {{ item.userAnswer || ('Training_Learner.Not_Answered' | translate) }}
          </p>
          <p class="result-item__answer result-item__answer--correct">
            {{ ('Training_Learner.Correct_Answer' | translate) }} {{ item.question.options[item.question.correctIndex] }}
          </p>
        } @else {
          <p class="result-item__answer result-item__answer--correct">
            ✓ {{ 'Training_Learner.Correct' | translate }}
            <span *ngIf="item.userAnswer">({{ item.userAnswer }})</span>
          </p>
        }
        <p class="result-item__explanation">{{ item.question.explanation }}</p>
      </div>
    }
  </div>
</div>
}
